$('.hero-video-cards-slider').slick({
  slidesToShow: 2,
  arrows: false,
  dots:true,
  autoplay: true,
  responsive: [ { breakpoint: 768, settings: { slidesToShow: 1 } }]
});

$('.testimonials-cards-grid').slick({
  slidesToShow: 2,
  autoplay: true,
  responsive: [ { breakpoint: 768, settings: { slidesToShow: 1 } }]
});

$('.custom-life-slider').slick({
  slidesToShow: 1,
  arrows: false,
  autoplay: true,
});

$('.custom-collections-switch button').click(function() {
    $(this).addClass('active').siblings().removeClass('active');
    $('.custom-collections-tab-body').find('[data-id="'+$(this).attr('id')+'"]').removeClass('hidden').siblings().addClass('hidden');
})

if(!window.location.href.includes('pages/work-dit-o')){
  $('.custom-vacancy-cards-slider').slick({
    slidesToShow: 4,
    arrows: false,
    dots:true,
    autoplay: true,
    responsive: [ 
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 989, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  });
}

const lenis = new Lenis({
    autoRaf: !0,
    wheelMultiplier: .6,
    easing: 2000,
    smoothWheel: true,
    smoothTouch: true
});

if($(document).find('.about-us-image').length){
    gsap.to(".about-us-image", {
      backgroundPositionY: "-100px", // or any value like "100px"
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: ".about-us-main",
        start: "top 80%",  // starts when section enters viewport
        end: "80% top",    // ends when section leaves
        // markers: true,       // Set to true to debug
        scrub: true          // If you want it tied to scroll, set to true
      }
    });
}

gsap.to("main#MainContent .shopify-section:first-child img", {
  y: "50px", // or any value like "100px"
  ease: "power1.inOut",
  scrollTrigger: {
    trigger: "main#MainContent .shopify-section:first-child",
    start: "top top",  // starts when section enters viewport
    end: "80% top",    // ends when section leaves
    // markers: true,       // Set to true to debug
    scrub: true          // If you want it tied to scroll, set to true
  }
});

gsap.to("main#MainContent .shopify-section:nth-child(2) img", {
  y: "50px", // or any value like "100px"
  ease: "power1.inOut",
  scrollTrigger: {
    trigger: "main#MainContent .shopify-section:nth-child(2)",
    start: "bottom top",  // starts when section enters viewport
    end: "80% top",    // ends when section leaves
    // markers: true,       // Set to true to debug
    scrub: true          // If you want it tied to scroll, set to true
  }
});